import { dayjs as _dayjs } from '@sc/data-access-models';

const dayjs = _dayjs;

export default dayjs;
